import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import { getTopics } from "../../../redux/topic/topicSelectors";
import { fetchAllTopics, createTopic, updateTopic, deleteTopic, showAlert } from "../../../redux";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import { requestState } from "../../../redux/type/type";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const Topic = (props) => {
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);

  const handleCreateModalOpen = () => setOpenCreate(true);
  const handleCreateModalClose = () => setOpenCreate(false);
  
  const handleEditModalOpen = (topic) => {
    setSelectedTopic(topic);
    setOpenEdit(true);
  };
  const handleEditModalClose = () => {
    setSelectedTopic(null);
    setOpenEdit(false);
  };

  const { topics, fetchAllTopics, createTopic, updateTopic, deleteTopic } = props;

  useEffect(() => {
    fetchAllTopics();
  }, []);

  const createTopicHandler = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const topicData = {
      topic_name: data.get('topic_name'),
      topic_slug: data.get('topic_slug'),
      topic_description: data.get('topic_description')
    };
    
    try {
      await createTopic(topicData).unwrap();
      handleCreateModalClose();
      props.showAlert("Topic created successfully!", "success");
      fetchAllTopics();
    } catch (rejectedValueOrSerializedError) {
      props.showAlert("Topic creation failed!", "error");
    }
  };

  const updateTopicHandler = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const topicData = {
      topic_name: data.get('topic_name'),
      topic_slug: data.get('topic_slug'),
      topic_description: data.get('topic_description')
    };
    
    try {
      await updateTopic({ id: selectedTopic.id, value: topicData }).unwrap();
      handleEditModalClose();
      props.showAlert("Topic updated successfully!", "success");
      fetchAllTopics();
    } catch (rejectedValueOrSerializedError) {
      props.showAlert("Topic update failed!", "error");
    }
  };

  const deleteTopicHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this topic?")) {
      try {
        await deleteTopic(id).unwrap();
        props.showAlert("Topic deleted successfully!", "success");
        fetchAllTopics();
      } catch (rejectedValueOrSerializedError) {
        props.showAlert("Topic deletion failed!", "error");
      }
    }
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
  };

  if (topics.status === requestState.loading) {
    return <div>Loading....</div>;
  } else {
    return (
      <>
        <Grid container spacing={3} alignItems="center" columns={12}>
          <Grid
            sx={{
              width: "100%",
              margin: 0,
              display: "flex"
            }}
            justifyContent="space-between"
          >
            <Typography variant="h6" gutterBottom>
              Topics
            </Typography>
            <Button variant="contained" onClick={handleCreateModalOpen}>
              Add Topic
            </Button>
          </Grid>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="topics table">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Slug</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {topics.topics.map((topic) => (
                    <TableRow key={topic.id}>
                      <TableCell>{topic.id}</TableCell>
                      <TableCell>{topic.topic_name}</TableCell>
                      <TableCell>{topic.topic_slug}</TableCell>
                      <TableCell>{topic.topic_description}</TableCell>
                      <TableCell align="right">
                        <IconButton 
                          color="primary" 
                          onClick={() => handleEditModalOpen(topic)}
                          title="Edit Topic"
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton 
                          color="error" 
                          onClick={() => deleteTopicHandler(topic.id)}
                          title="Delete Topic"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* Create Topic Modal */}
        <Modal
          open={openCreate}
          onClose={handleCreateModalClose}
          aria-labelledby="create-topic-modal"
        >
          <Box sx={modalStyle} component="form" onSubmit={createTopicHandler}>
            <Typography id="create-topic-modal" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
              Create Topic
            </Typography>
            <TextField
              fullWidth
              label="Topic Name"
              id="topic_name"
              name="topic_name"
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Topic Slug"
              id="topic_slug"
              name="topic_slug"
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Description"
              id="topic_description"
              name="topic_description"
              multiline
              rows={3}
            />
            <Box display='flex' justifyContent='flex-end'>
              <Button variant="contained" size="small" type="submit" sx={{ marginTop: '10px' }}>
                Create
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Edit Topic Modal */}
        <Modal
          open={openEdit}
          onClose={handleEditModalClose}
          aria-labelledby="edit-topic-modal"
        >
          <Box sx={modalStyle} component="form" onSubmit={updateTopicHandler}>
            <Typography id="edit-topic-modal" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
              Edit Topic
            </Typography>
            <TextField
              fullWidth
              label="Topic Name"
              id="topic_name"
              name="topic_name"
              defaultValue={selectedTopic?.topic_name}
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Topic Slug"
              id="topic_slug"
              name="topic_slug"
              defaultValue={selectedTopic?.topic_slug}
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Description"
              id="topic_description"
              name="topic_description"
              defaultValue={selectedTopic?.topic_description}
              multiline
              rows={3}
            />
            <Box display='flex' justifyContent='flex-end'>
              <Button variant="contained" size="small" type="submit" sx={{ marginTop: '10px' }}>
                Update
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    topics: getTopics(state),
    alert: state.alert
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllTopics: () => dispatch(fetchAllTopics()),
    createTopic: (topicData) => dispatch(createTopic(topicData)),
    updateTopic: (data) => dispatch(updateTopic(data)),
    deleteTopic: (id) => dispatch(deleteTopic(id)),
    showAlert: (message, type) => dispatch(showAlert(message, type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Topic);
